import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import SectionHeader from "./ui/SectionHeader";
import { cn, spacing, animations } from "../utils/cn";

const Experience = () => {
  const { t } = useTranslation();

  const experiences = [
    {
      title: t('experience.positions.fullstackIntern'),
      company: t('experience.companies.a3bat'),
      location: t('experience.locations.marseille'),
      period: "April 2025 — July 2025",
      description: t('experience.descriptions.a3bat', { returnObjects: true }),
    },

    {
      title: t('experience.positions.frontendDev'),
      company: t('experience.companies.ainuw'),
      location: t('experience.locations.marseille'),
      period: "July 2024 — September 2024",
      description: t('experience.descriptions.ainuw', { returnObjects: true }),
    },
    {
      title: t('experience.positions.frontendIntern'),
      company: t('experience.companies.pelom'),
      location: t('experience.locations.spain'),
      period: "April 2024 — June 2024",
      description: t('experience.descriptions.pelom', { returnObjects: true }),
    },
    {
      title: t('experience.positions.frontendDev'),
      company: t('experience.companies.autoEntrepreneur'),
      location: t('experience.locations.marseille'),
      period: "October 2022 — April 2024",
      description: t('experience.descriptions.autoEntrepreneur', { returnObjects: true }),
    },
    {
      title: t('experience.positions.itAdmin'),
      company: t('experience.companies.ebullient'),
      location: t('experience.locations.nairobi'),
      period: "October 2020 — September 2023",
      description: t('experience.descriptions.ebullient', { returnObjects: true }),
    },
  ];

  return (
    <section id="experience" className={cn("bg-navy", spacing.section)}>
      <div className={spacing.container}>
        <motion.div {...animations.fadeInUp}>
          <SectionHeader number="03" title={t('experience.title')} />

          <div className="space-y-8 sm:space-y-10 lg:space-y-12">
            {experiences.map((exp, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 25 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className="group"
              >
                <div className="border-l-2 border-accent/20 pl-4 sm:pl-6 lg:pl-8 pb-6 sm:pb-8 relative">
                  {/* Timeline dot */}
                  <div className="absolute w-3 h-3 sm:w-4 sm:h-4 bg-accent rounded-full -left-1.5 sm:-left-2 top-0 group-hover:scale-125 transition-transform duration-300"></div>

                  {/* Job Title and Company */}
                  <div className="mb-2">
                    <h3 className="text-lg sm:text-xl lg:text-2xl font-semibold text-lighterSlate group-hover:text-accent transition-colors duration-300">
                      {exp.title}
                      <span className="text-accent"> @ {exp.company}</span>
                    </h3>
                    <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2 lg:gap-4 mt-1">
                      <p className="text-xs sm:text-sm font-mono text-slate">
                        {exp.period}
                      </p>
                      <p className="text-xs sm:text-sm text-lightSlate">
                        {exp.location}
                      </p>
                    </div>
                  </div>

                  {/* Job Description */}
                  <ul className="space-y-2 sm:space-y-3 mt-3 sm:mt-4">
                    {(Array.isArray(exp.description) ? exp.description : [exp.description]).map((item, itemIndex) => (
                      <li key={itemIndex} className="flex items-start">
                        <span className="text-accent mr-2 sm:mr-3 mt-1 sm:mt-2 text-sm">
                          ▹
                        </span>
                        <span className="text-slate leading-relaxed text-sm sm:text-base">
                          {item}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Experience;
